import OkC from "shared/util/OkcApi";

export function recordStartOnboarding() {
	return OkC.post("/signup/start", {
		api: 1,
	});
}



// WEBPACK FOOTER //
// ./src/apps/splash_mobile/util/web.js